import { z } from "zod";

import { regexSchema } from "@utils/helpers/zod";

export const DATE_REGEX =
  /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
export const DATE_ISO_8601_REGEX =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/;
export const DATE_STANDARD_REGEX =
  /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d{2}$/;
export const TIME_REGEX = /^(0[1-9]|1[0-2]):[0-5][0-9]:[0-5][0-9] (AM|PM)$/;

export const numberSchema = z.union([
  z.number().finite(),
  z
    .string()
    .regex(/^-?\d*\.?\d+(?:[eE][-+]?\d+)?$/)
    .transform(Number),
]);

export const decimalStringSchema = z
  .string()
  .regex(/^-?\d*\.?\d+$/)
  .refine((val) => !isNaN(parseFloat(val)), {
    message: "Must be a valid decimal number",
  });

export const bigintSchema = z.union([
  z.bigint(),
  z
    .string()
    .regex(/^-?\d+$/)
    .transform(BigInt),
]);

export const hexStringSchema = z
  .string()
  .startsWith("0x")
  .transform((val): `0x${string}` => val as `0x${string}`);
export type HexString = z.infer<typeof hexStringSchema>;

export const addressSchema = hexStringSchema;
export type Address = z.infer<typeof addressSchema>;

export const instructionIdSchema = hexStringSchema;
export type InstructionId = z.infer<typeof instructionIdSchema>;

export const transactionHashSchema = hexStringSchema;
export type TransactionHash = z.infer<typeof transactionHashSchema>;

export const dateSchema = regexSchema(DATE_REGEX);
export const dateISO8601Schema = regexSchema(DATE_ISO_8601_REGEX);
export const dateStandardSchema = regexSchema(DATE_STANDARD_REGEX);

export const timeSchema = regexSchema(TIME_REGEX);

export const Sort = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type Sort = (typeof Sort)[keyof typeof Sort];
export const sortValues = Object.values(Sort) as [Sort, ...Sort[]];
